export const PROGRAM_BENEFITS_4_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    meta_priority: "1",
    meta_eligibility_orange: "",
    meta_total_fee_label: "Total Fee",
    meta_total_fee_amount: "₹1,77,000",
    meta_block_label: "Block Your Seat Now At",
    meta_block_amount: "₹10,000",
    meta_emi_label: "EMI per Month",
    meta_emi_amount: "₹6,031",
    meta_footnote_1:
      "*Fees inclusive of taxes. EMI amount is indicative; terms from partner NBFC.",
    meta_footnote_1_color: "#6B6B6B",
    meta_footnote_2: "",
    meta_footnote_2_color: "#6B6B6B",
    meta_prerequisite_label: "Prerequisite:",
    meta_prerequisite_label_color: "#D32F2F",
    meta_prerequisite_text:
      "2+ years professional software development; Python or JavaScript/TypeScript proficiency.",
    meta_prerequisite_text_color: "#2C2C2C",
    meta_cta_url: "",
    meta_total_fee_box_bg: "#1A1A4B",
    meta_secondary_box_bg: "#E8EAF6",
    meta_secondary_border: "#1A1A4B",
    meta_navy_text: "#1A1A4B",
    meta_accent_orange: "#E67E22",
    meta_prerequisite_box_bg: "#F3F4F8",
    meta_prerequisite_box_border: "#D7DAE5",
    meta_subtitle_color: "#4A4A4A",
  },

  PROGRAM_BENEFITS_4_FIELDS_CONFIG: [
    {
      fieldName: "desktop_background_color",
      label: "Section background",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "title",
      label: "Title — part 1 (dark)",
      value: "EPGC in AI",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. EPGC in AI",
      required: true,
      defaultValue: "EPGC in AI",
    },
    {
      fieldName: "title_start_color",
      label: "Title part 1 color",
      value: "#171719",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#171719",
      required: false,
      defaultValue: "#171719",
    },
    {
      fieldName: "pre_title",
      label: "Title — part 2 (accent, e.g. course fee line)",
      value: "– Native Software Engineering Course Fee",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Second part of headline",
      required: false,
      defaultValue: "– Native Software Engineering Course Fee",
    },
    {
      fieldName: "pre_title_color",
      label: "Title part 2 color",
      value: "#E67E22",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#E67E22",
      required: false,
      defaultValue: "#E67E22",
    },
    {
      fieldName: "subtitle",
      label: "Subtext (below title)",
      value:
        "Flexible payment options and zero cost EMIs make your programme even more accessible.",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Supporting line",
      required: false,
      defaultValue:
        "Flexible payment options and zero cost EMIs make your programme even more accessible.",
    },
    {
      fieldName: "button_text",
      label: "CTA label",
      value: "Apply Now",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Apply Now",
      required: false,
      defaultValue: "Apply Now",
    },
    {
      fieldName: "button_color",
      label: "CTA background",
      value: "#E67E22",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#E67E22",
      required: false,
      defaultValue: "#E67E22",
    },
    {
      fieldName: "button_text_color",
      label: "CTA text",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "button_is_cta",
      label: "Is CTA — Apply (lead popup)",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder:
        "On = lead capture popup; off = direct CTA URL from table (below)",
      required: false,
      defaultValue: true,
    },
    {
      fieldName: "status",
      label: "Section status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable",
      defaultValue: false,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Subtext color",
      fieldName: "meta_subtitle_color",
      value: "#4A4A4A",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#4A4A4A",
      defaultValue: "#4A4A4A",
    },
    {
      header: "CTA URL",
      fieldName: "meta_cta_url",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "https://…",
    },
    {
      header: "Eligibility / highlight (orange paragraph)",
      fieldName: "meta_eligibility_orange",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Academic requirements, shown in accent color",
    },
    {
      header: "Accent orange (eligibility text)",
      fieldName: "meta_accent_orange",
      value: "#E67E22",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#E67E22",
      defaultValue: "#E67E22",
    },
    {
      header: "Total fee — label",
      fieldName: "meta_total_fee_label",
      value: "Total Fee",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Total Fee",
    },
    {
      header: "Total fee — amount",
      fieldName: "meta_total_fee_amount",
      value: "₹1,77,000",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "₹1,77,000",
    },
    {
      header: "Total fee box background (hex or CSS gradient)",
      fieldName: "meta_total_fee_box_bg",
      value: "#1A1A4B",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "#1A1A4B or linear-gradient(135deg, #1A1A4B, #3A3A7B)",
      defaultValue: "#1A1A4B",
    },
    {
      header: "Block seat — label",
      fieldName: "meta_block_label",
      value: "Block Your Seat Now At",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Block Your Seat Now At",
    },
    {
      header: "Block seat — amount",
      fieldName: "meta_block_amount",
      value: "₹10,000",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "₹10,000",
    },
    {
      header: "EMI — label",
      fieldName: "meta_emi_label",
      value: "EMI per Month",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "EMI per Month",
    },
    {
      header: "EMI — amount",
      fieldName: "meta_emi_amount",
      value: "₹6,031",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "₹6,031",
    },
    {
      header: "Side boxes background",
      fieldName: "meta_secondary_box_bg",
      value: "#E8EAF6",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#E8EAF6",
      defaultValue: "#E8EAF6",
    },
    {
      header: "Side boxes border",
      fieldName: "meta_secondary_border",
      value: "#1A1A4B",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#1A1A4B",
      defaultValue: "#1A1A4B",
    },
    {
      header: "Side boxes text (navy)",
      fieldName: "meta_navy_text",
      value: "#1A1A4B",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#1A1A4B",
      defaultValue: "#1A1A4B",
    },
    {
      header: "Footnote line 1",
      fieldName: "meta_footnote_1",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "*Fees inclusive of taxes…",
    },
    {
      header: "Footnote line 1 color",
      fieldName: "meta_footnote_1_color",
      value: "#6B6B6B",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#6B6B6B",
      defaultValue: "#6B6B6B",
    },
    {
      header: "Footnote line 2",
      fieldName: "meta_footnote_2",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Optional second footnote",
    },
    {
      header: "Footnote line 2 color",
      fieldName: "meta_footnote_2_color",
      value: "#6B6B6B",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#6B6B6B",
      defaultValue: "#6B6B6B",
    },
    {
      header: "Prerequisite — label",
      fieldName: "meta_prerequisite_label",
      value: "Prerequisite:",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Prerequisite:",
    },
    {
      header: "Prerequisite — label color",
      fieldName: "meta_prerequisite_label_color",
      value: "#D32F2F",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#D32F2F",
      defaultValue: "#D32F2F",
    },
    {
      header: "Prerequisite — body",
      fieldName: "meta_prerequisite_text",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Requirements text",
    },
    {
      header: "Prerequisite — body color",
      fieldName: "meta_prerequisite_text_color",
      value: "#2C2C2C",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#2C2C2C",
      defaultValue: "#2C2C2C",
    },
    {
      header: "Prerequisite box background",
      fieldName: "meta_prerequisite_box_bg",
      value: "#F3F4F8",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#F3F4F8",
      defaultValue: "#F3F4F8",
    },
    {
      header: "Prerequisite box border",
      fieldName: "meta_prerequisite_box_border",
      value: "#D7DAE5",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#D7DAE5",
      defaultValue: "#D7DAE5",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: "1",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "1",
      required: true,
    },
  ],
};
